import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDevopsLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "f4337506-5d95-4e80-b7ca-68498c6e008e",
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "ba420277-700e-42cc-9de9-5388a5c16e54",
		x1: 9,
		y1: 16.97,
		x2: 9,
		y2: 1.03,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#0078d4"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .16,
				stopColor: "#1380da"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .53,
				stopColor: "#3c91e5"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .82,
				stopColor: "#559cec"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#5ea0ef"
			})
		]
	}) }), /* @__PURE__ */ _jsx("path", {
		id: "a91f0ca4-8fb7-4019-9c09-0a52e2c05754",
		d: "M17,4v9.74l-4,3.28-6.2-2.26V17L3.29,12.41l10.23.8V4.44Zm-3.41.49L7.85,1V3.29L2.58,4.84,1,6.87v4.61l2.26,1V6.57Z",
		fill: "url(#ba420277-700e-42cc-9de9-5388a5c16e54)"
	})]
});
export default SvgDevopsLogo;
